<template>
  <div>
    <v-dialog v-model="model" max-width="400" scrollable persistent>
      <v-card>
        <v-toolbar dark color="primary" elevation="0">
          <v-toolbar-title>Cancelar atendimento
          </v-toolbar-title>
          <v-spacer/>
          <v-btn class="close__button" text @click="fecharModal" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-5">
          <div class="container-aviso-cancelamento">
            <div>
              <v-icon color="white">mdi-alert-circle-outline</v-icon>
              <span class="ml-2">Atenção!</span></div>
            <label>Todos os procedimentos vinculados a esse atendimento serão removidos do sistema e as cobranças serão
              automaticamente <strong>canceladas.</strong></label>
          </div>
          <v-row wrap align-center white>
            <v-col cols="12" md="12" sm="12" xs="12">
              <v-textarea
                  v-model="motivoCancelamento"
                  name="motivo"
                  placeholder="Informe o motivo do cancelamento"
                  filled
                  auto-grow
                  counter="255"
                  maxlength="255"
                  v-validate="{required: true, min: 2, max: 255}"
                  :error-messages="errors.collect('motivo')">
                <template v-slot:label>
                  Motivo
                  <span class="ml-1 red--text">*</span>
                </template>
              </v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-container>
          <v-row wrap align-center white class="pl-10 pr-10 row-bottom">
            <botao-cancelar @cancelar="fecharModal" text="Voltar"/>
            <div style="display: flex; flex-direction: row">
              <botao-salvar @salvar="tratarEventoConfirmar" texto="Confirmar"/>
            </div>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
import BotaoSalvar from '@/views/components/BotaoSalvar'
import BotaoCancelar from '@/views/components/BotaoCancelar'


export default {
    name: 'CancelarAtendimentoModal',
    components: {BotaoCancelar, BotaoSalvar},
    props: {
        value: {
            type: Boolean,
            required: true
        },
    },
    data() {
        return {
            motivoCancelamento: null,
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    methods: {
        async tratarEventoConfirmar() {
            if (await this.validarDadosFormulario()) {
                this.$emit('confirmarCancelarAtendimento', this.motivoCancelamento)
            }
        },
        async validarDadosFormulario() {
            return this.$validator._base.validateAll()
        },
        fecharModal() {
            this.model = false
            this.$emit('fecharModalCancelar')
        },
    }
}
</script>

<style scoped lang="stylus">

.row-bottom
  border-top-width 1px
  border-top-style solid
  border-top-color #ccc
  box-sizing border-box
  padding-top 10px
  padding-bottom 10px
  display flex
  justify-content space-between

.container-aviso-cancelamento
  background-color #fb8c00
  color white
  padding 10px
  margin-bottom 30px
  border-radius 5px

  div
    margin-bottom 10px

  span
    font-weight bold


</style>